// Núcleo da geometria — preços, helper e função de cálculo.
// As geometrias por modelo ficam em arquivos separados por categoria
// e são montadas em ../geometria.js.

export const PRECOS_MDF = {
  '15_branco': 58.28,
  '15_cor':    97.13,
  '15_laca':   133.55,
  '25_branco': 106.84,
  '25_cor':    157.84,
  '25_laca':   180.00,
  '6_branco':  43.71,
  '6_cor':     67.99,
}

export const PRECOS_FERRAGEM = {
  dobradica: 3.00,
  corredica: 15.00,
  pistao:    9.00,
  rodinha:   12.00,
  cabide:    30.00,
}

// p(nome, esp, formulaFn, qtd, cor)
//   esp:  '15' | '25' | '6'
//   qtd:  número | (v) => número
//   cor:  'cor' (default — segue cor escolhida pelo cliente)
//       | 'branco' (sempre branco — interior do móvel, mesmo quando a peça
//         está dentro de um móvel de cor: gavetas, fundos, divisórias internas)
//
// Regra Mini Marcenaria: interior é branco. Peça é 'cor' quando exposta ao
// usuário (frentes, portas, laterais visíveis, tampos) ou quando a peça em
// si é uma face dupla na cor (lateral aparente).
export function p(nome, esp, f, qtd, cor = 'cor') {
  return { nome, esp, f, qtd, cor }
}

export function calcularCusto(GEOMETRIA, modeloNome, vars, tipoCor, perdaPct = 0.10) {
  const geo = GEOMETRIA[modeloNome]
  if (!geo) return null

  let m2_15_cor = 0, m2_15_branco = 0
  let m2_25_cor = 0, m2_25_branco = 0
  let m2_6 = 0
  const detalhe = []

  for (const peca of geo.pecas) {
    const areaUnit = peca.f(vars)
    const qtd      = typeof peca.qtd === 'function' ? peca.qtd(vars) : peca.qtd
    const area     = areaUnit * qtd
    const eBranco  = peca.cor === 'branco'

    if (peca.esp === '6')       m2_6  += area
    else if (peca.esp === '25') { if (eBranco) m2_25_branco += area; else m2_25_cor += area }
    else                        { if (eBranco) m2_15_branco += area; else m2_15_cor += area }

    detalhe.push({ nome: peca.nome, esp: peca.esp, cor: eBranco ? 'branco' : tipoCor, qtd, areaUnit, area })
  }

  const suf15cor = tipoCor === 'laca' ? 'laca' : tipoCor === 'cor' ? 'cor' : 'branco'
  const suf25cor = tipoCor === 'laca' ? 'laca' : tipoCor === 'cor' ? 'cor' : 'branco'

  const pm = PRECOS_MDF
  const c15cor    = m2_15_cor    * pm[`15_${suf15cor}`]
  const c15branco = m2_15_branco * pm['15_branco']
  const c25cor    = m2_25_cor    * pm[`25_${suf25cor}`]
  const c25branco = m2_25_branco * pm['25_branco']
  const c6        = m2_6         * pm['6_branco']

  const c15 = c15cor + c15branco
  const c25 = c25cor + c25branco
  const custoMdfBruto = c15 + c25 + c6
  const custoMdf      = custoMdfBruto * (1 + perdaPct)

  const ferr = typeof geo.ferragens === 'function' ? geo.ferragens(vars) : geo.ferragens
  const pf   = PRECOS_FERRAGEM
  const custoFerr =
    ferr.dobradica * pf.dobradica +
    ferr.corredica * pf.corredica +
    ferr.pistao    * pf.pistao    +
    ferr.rodinha   * pf.rodinha   +
    ferr.cabide    * pf.cabide

  return {
    m2_15: m2_15_cor + m2_15_branco, m2_25: m2_25_cor + m2_25_branco, m2_6,
    m2_15_cor, m2_15_branco, m2_25_cor, m2_25_branco,
    c15, c25, c6,
    custoMdfBruto, custoMdf,
    ferr, custoFerr,
    custoBase: custoMdf + custoFerr,
    detalhe,
    suf15: suf15cor, suf25: suf25cor,
  }
}
